import { render, staticRenderFns } from "./create-credit-note.vue?vue&type=template&id=bdf87a94&scoped=true"
import script from "./create-credit-note.vue?vue&type=script&lang=js"
export * from "./create-credit-note.vue?vue&type=script&lang=js"
import style0 from "./create-credit-note.vue?vue&type=style&index=0&id=bdf87a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf87a94",
  null
  
)

export default component.exports